(function () {
  function formatRatingText(count) {
    var n = parseInt(count, 10);
    if (isNaN(n)) return null;
    return n + (n === 1 ? ' rating' : ' ratings');
  }

  function applyRatingText(badge) {
    if (badge.dataset.spotlightRatingApplied) return;

    var reviewCount = badge.getAttribute('data-number-of-reviews');
    if (reviewCount === null) return; // Judge.me hasn't populated this badge yet

    var textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;

    var text = formatRatingText(reviewCount);
    if (text === null) return;

    textEl.textContent = text;
    badge.dataset.spotlightRatingApplied = 'true';
  }

  function processSection(section) {
    if (section.dataset.ratingDisplay !== 'text') return;

    var badges = section.querySelectorAll('.jdgm-prev-badge');
    badges.forEach(applyRatingText);

    if (section.dataset.ratingObserverBound) return;
    section.dataset.ratingObserverBound = 'true';

    // Judge.me populates these badges asynchronously after its own script
    // loads, so watch for the data attribute appearing rather than assuming
    // it's there on DOMContentLoaded.
    var observer = new MutationObserver(function () {
      section.querySelectorAll('.jdgm-prev-badge').forEach(applyRatingText);
    });
    observer.observe(section, {subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews'], childList: true});
  }

  function init() {
    document.querySelectorAll('.tab-collections[data-rating-display="text"]').forEach(processSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
